import React from 'react';
import BadgeIcon from "../BadgeIcon/BadgeIcon";

function Badge(props) {

    return <BadgeIcon {...props} />

}

export default Badge;